<app-request-quote></app-request-quote>
<app-campaign-details></app-campaign-details>

<button
  #openVehicleModalBtn
  style="display: none"
  [ds-modal-trigger-for]="vehicleDetailsModal"
></button>

<div class="table-section">
  <div class="table-scroll-container">
    <table *ngIf="showTable" class="ds-table zebra-table fixed-header-table">
      <thead>
        <tr class="table_head">
          <th *ngFor="let column of columnData">{{ column.headerName }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of rowsData"
          [ngClass]="{
            campaignitem: row['deliveryStop'] === 'Y',
            deliverystopitem: row['deliveryStop'] === 'R',
            'highlight-row': checkCampaignItem(row['deliveryStop']),
          }"
          [style.backgroundColor]=" checkDemoDocIndictor(row['docIndicator'])
            ||checkCampaignItem(row['deliveryStop'])"
        >
          <td
            *ngFor="let column of columnData"
            [ngClass]="{ 'image-column': column.field === 'image' }"
          >
            <ng-container *ngIf="column.field === 'image'; else defaultCell">
                @if (row['image'] === '') {
                    <ds-progress-circle
                            size="sm"
                            class="image-loader"
                    ></ds-progress-circle>
                } @else {
              <div class="image-popup-wrapper">
                <img
                  [src]="row[column.field]"
                  alt="Car Image"
                  class="car-thumbnail"
                />
                <div class="image-hover-popup">
                  <img [src]="row[column.field]" alt="Vehicle Enlarged View" />
                </div>
              </div>
                }
            </ng-container>

            <ng-template #defaultCell>
              <ng-container
                *ngIf="column.field === 'download'; else defaultText"
              >
                <span class="d-flex align-items-center gap-2">
                  <!-- Eye Icon -->
                  <ds-icon
                    icon="eye"
                    size="md"
                    title="Unit Summary"
                    style="cursor: pointer; color: #037493; margin-left: 10px"
                    class="action"
                    (click)="openVehicleDetailsModal(row)"
                  ></ds-icon>

                  <!-- Download Icon -->
                  <ds-icon
                    icon="download"
                    size="md"
                    (click)="onDownloadClick(row['VIN'])"
                    role="button"
                    (keydown)="onKeyDown($event, row['VIN'], 'download')"
                    tabindex="0"
                    style="
                      cursor: pointer;
                      color: #037493;
                      margin-top: -3px;
                      margin-left: 15px;
                    "
                    title="Download Showroom Document"
                  ></ds-icon>
                  <span *ngIf="checkCampaignItem(row['deliveryStop'])">
                    <ds-icon
                      icon="profile"
                      size="md"
                      (click)="
                        getCampaignDetails(
                          row['VIN'],
                          row['deliveryStop'],
                          row['image'],
                          row['model']
                        )
                      "
                      role="button"
                      tabindex="0"
                      style="
                        cursor: pointer;
                        color: #037493;
                        margin-left: 9px;
                        margin-top: 4px;
                      "
                      title="View Campaign Details"
                    ></ds-icon>
                  </span>
                </span>
              </ng-container>
              <ng-template #defaultText>
                <ng-container
                  *ngIf="
                    column.field === 'storageLocationAvailable';
                    else otpActionCheck
                  "
                >
                  <div style="display: flex; align-items: center">
                    {{ row[column.field] }}
                    <span
                      *ngIf="row[column.field] === 'Basement'"
                      class="actionbutton pull-right"
                    >
                      <ds-icon
                        icon="exchange"
                        size="md"
                        title="Transfer to showroom"
                        class="action transfer"
                        (click)="modalClickData(row['VIN'], row['model'])"
                        (keydown)="
                          onKeyDown(
                            $event,
                            row['VIN'],
                            'transfer',
                            row['model']
                          )
                        "
                        style="
                          cursor: pointer;
                          color: #037493;
                          margin-left: 26px;
                        "
                      ></ds-icon>
                    </span>
                  </div>
                </ng-container>

                <ng-template #otpActionCheck>
                  <ng-container
                    *ngIf="
                      column.field === 'otpAction';
                      else inBoundActionCheck
                    "
                  >
                    <div>
                      <div style="display: flex; gap: 8px; align-items: center">
                        <span>
                          <ds-icon
                            icon="eye"
                            size="md"
                            title="Unit Summary"
                            style="
                              cursor: pointer;
                              color: #037493;
                              margin-left: 10px;
                              margin-left: 10px;
                            "
                            class="action transfer"
                            (click)="openVehicleDetailsModal(row)"
                          ></ds-icon>
                        </span>
                        <span *ngIf="checkCampaignItem(row['deliveryStop'])">
                          <ds-icon
                            icon="profile"
                            size="md"
                            (click)="
                              getCampaignDetails(
                                row['VIN'],
                                row['deliveryStop'],
                                row['image'],
                                row['model']
                              )
                            "
                            role="button"
                            tabindex="0"
                            style="
                              cursor: pointer;
                              color: #037493;
                              margin-left: 9px;
                              margin-top: 4px;
                            "
                            title="View Campaign Details"
                          ></ds-icon>
                        </span>

                        <span
                          *ngIf="row['otpAction'] === 'plantMatch'"
                          class="actionbutton pull-right"
                          style="text-align: right"
                        >
                          <ds-icon
                            icon="download"
                            size="md"
                            title="Download Showroom Document"
                            style="
                              cursor: pointer;
                              color: #037493;
                              margin-top: -3px;
                              margin-left: 15px;
                            "
                            class="action transfer"
                            (click)="onDownloadClick(row['VIN'])"
                            (keydown)="
                              onKeyDown($event, row['VIN'], 'download')
                            "
                          ></ds-icon>
                        </span>
                        <span
                          *ngIf="isPofRobotRed(row['pofRobot'])"
                          class="actionbutton pull-right"
                        >
                          <ds-icon
                            icon="file_upload"
                            size="md"
                            title="Upload Finance Documentation"
                            style="cursor: pointer; color: red"
                            class="action transfer"
                            (click)="
                              modalOTPClickData(
                                row['VIN'],
                                row['model'],
                                row['dspReference']
                              )
                            "
                            (keydown)="
                              onKeyDown(
                                $event,
                                row['VIN'],
                                'transfer',
                                row['model']
                              )
                            "
                          ></ds-icon>
                        </span>
                        <span
                          *ngIf="isPofAttachedX(row['pofAttached'])"
                          class="actionbutton pull-right"
                          style="text-align: right"
                        >
                          <ds-icon
                            icon="file_download"
                            size="md"
                            title="View Finance Documentation"
                            style="cursor: pointer; color: green"
                            class="action transfer"
                            (click)="
                              viewFinanceDocumentation(
                                row['VIN'],
                                row['dspReference']
                              )
                            "
                            (keydown)="
                              onKeyDown(
                                $event,
                                row['VIN'],
                                'transfer',
                                row['model']
                              )
                            "
                          ></ds-icon>
                        </span>
                        <span
                          *ngIf="isPofRobotGreen(row['pofRobot'])"
                          class="actionbutton pull-right"
                        >
                          <ds-icon
                            icon="file_upload"
                            size="md"
                            title="Upload Finance Documentation"
                            style="cursor: pointer; color: green"
                            class="action transfer"
                            (click)="
                              modalOTPClickData(
                                row['VIN'],
                                row['model'],
                                row['dspReference']
                              )
                            "
                            (keydown)="
                              onKeyDown(
                                $event,
                                row['VIN'],
                                'transfer',
                                row['model']
                              )
                            "
                          ></ds-icon>
                        </span>
                        <span
                          *ngIf="isPofRobotAmber(row['pofRobot'])"
                          class="actionbutton pull-right"
                          style="text-align: right"
                        >
                          <ds-icon
                            icon="file_upload"
                            size="md"
                            title="Upload Finance Documentation"
                            style="cursor: pointer; color: #ffbf00"
                            class="action transfer"
                            (click)="
                              modalOTPClickData(
                                row['VIN'],
                                row['model'],
                                row['dspReference']
                              )
                            "
                            (keydown)="
                              onKeyDown(
                                $event,
                                row['VIN'],
                                'transfer',
                                row['model']
                              )
                            "
                          ></ds-icon>
                        </span>
                      </div>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #inBoundActionCheck>
                  <ng-container
                    *ngIf="
                      column.field === 'inBoundAction';
                      else reservedDownload
                    "
                  >
                    <div class="d-flex align-items-center gap-2">
                      <span>
                        <ds-icon
                          icon="eye"
                          size="md"
                          title="Unit Summary"
                          style="
                            cursor: pointer;
                            color: #037493;
                            margin-left: 10px;
                            margin-left: 10px;
                          "
                          class="action transfer"
                          (click)="openVehicleDetailsModal(row)"
                        ></ds-icon>
                      </span>
                      <span
                        *ngIf="row['inBoundAction'] === 'Transfer'"
                        class="actionbutton pull-right"
                      >
                        <ds-icon
                          icon="download"
                          size="md"
                          title="accept inbound vehicle"
                          style="
                            cursor: pointer;
                            color: #037493;
                            margin-top: -3px;
                            margin-left: 15px;
                          "
                          class="action transfer"
                          (click)="acceptInboundVehicle(row['VIN'])"
                          (keydown)="onKeyDown($event, row['VIN'], 'download')"
                        ></ds-icon>
                      </span>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #reservedDownload>
                  <ng-container
                    *ngIf="
                      column.field === 'reservedDownload';
                      else demoStockAction
                    "
                  >
                    <div class="d-flex align-items-center gap-2">
                      <ds-icon
                        icon="eye"
                        size="md"
                        title="Unit Summary"
                        style="
                          cursor: pointer;
                          color: #037493;
                          margin-left: 10px;
                          margin-left: 10px;
                        "
                        class="action transfer"
                        (click)="openVehicleDetailsModal(row)"
                      ></ds-icon>
                      <ds-icon
                        icon="download"
                        size="md"
                        role="button"
                        style="
                          cursor: pointer;
                          color: #037493;
                          margin-top: -3px;
                          margin-left: 15px;
                        "
                        (click)="onDownloadClick(row['VIN'])"
                        (keydown)="onKeyDown($event, row['VIN'], 'download')"
                        title="Download Showroom Document"
                      ></ds-icon>
                      <span *ngIf="checkCampaignItem(row['deliveryStop'])">
                          <ds-icon
                            icon="profile"
                            size="md"
                            (click)="
                              getCampaignDetails(
                                row['VIN'],
                                row['deliveryStop'],
                                row['image'],
                                row['model']
                              )
                            "
                            role="button"
                            tabindex="0"
                            style="
                              cursor: pointer;
                              color: #037493;
                              margin-left: 9px;
                              margin-top: 4px;
                            "
                            title="View Campaign Details"
                          ></ds-icon>
                        </span>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #demoStockAction>
                  <ng-container
                    *ngIf="
                      column.field === 'demoStockAction';
                      else nscStockAction
                    "
                  >
                    <div style="display: flex; gap: 8px; align-items: center">
                      <span>
                        <ds-icon
                          icon="eye"
                          size="md"
                          title="Unit Summary"
                          style="
                            cursor: pointer;
                            color: #037493;
                            margin-left: 10px;
                          "
                          class="update millage"
                          (click)="openVehicleDetailsModal(row)"
                        ></ds-icon>
                      </span>
                      <span *ngIf="row['lastAction'] !== 'INVOICED'">
                        <ds-icon
                          icon="repeat"
                          size="md"
                          title="Update vehicle mileage"
                          (click)="
                            updateMileageModalClicked(
                              row['modelDescription'],
                              row['VIN'],
                              row['mileage']
                            )
                          "
                          style="cursor: pointer; color: #037493"
                          class="update millage"
                        ></ds-icon>
                      </span>
                      <span
                        *ngIf="
                          isItemValid(row['lastAction'], row['docIndicator'])
                        "
                      >
                        <ds-icon
                          icon="upload"
                          size="md"
                          title="Upload registration documents"
                          style="cursor: pointer; color: #037493"
                          class="update millage"
                          (click)="openLicenseUploadModal(row['VIN'],row['modelDescription'])"
                        ></ds-icon>
                      </span>
                      <span>
                        <ds-icon
                          icon="todo"
                          size="md"
                          title="Request Inspection"
                          (click)="
                            requestInspectionModalClicked(
                              row['modelDescription'],
                              row['VIN'],
                              row['appraisalStatus']
                            )
                          "
                          style="cursor: pointer; color: #037493"
                          class="update millage"
                        ></ds-icon>
                      </span>
                      <span
                        *ngIf="
                          isAppraisalStatusUploaded(row['appraisalStatus'])
                        "
                      >
                        <ds-icon
                          icon="download"
                          size="md"
                          title="Download Inspection report"
                          (click)="
                            downloadInspectionReport(
                              row['bmwOrderNumber'],
                              row['tuvSudRefNumber']
                            )
                          "
                          style="
                            cursor: pointer;
                            color: #037493;
                            margin-top: -3px;
                            margin-left: 15px;
                          "
                          class="update millage"
                        ></ds-icon>
                      </span>
                      <span *ngIf="row['lastAction'] !== 'INVOICED'">
                        <ds-icon
                          icon="share_box"
                          size="md"
                          (click)="openRequestQuoteModal(row['VIN'])"
                          title="Request Quote"
                          style="cursor: pointer; color: #037493"
                          class="update millage"
                        ></ds-icon>
                      </span>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #nscStockAction>
                  <ng-container
                    *ngIf="column.field === 'nscAction'; else quotationAction"
                  >
                    <div>
                      <span
                        style="display: flex; gap: 8px; align-items: center"
                      >
                        <span>
                          <ds-icon
                            icon="eye"
                            size="md"
                            title="Unit Summary"
                            style="
                              cursor: pointer;
                              color: #037493;
                              margin-left: 10px;
                            "
                            class="update millage"
                            (click)="openVehicleDetailsModal(row)"
                          ></ds-icon>
                        </span>
                        <span *ngIf="checkCampaignItem(row['deliveryStop'])">
                          <ds-icon
                            icon="profile"
                            size="md"
                            (click)="
                              getCampaignDetails(
                                row['VIN'],
                                row['deliveryStop'],
                                row['image'],
                                row['model']
                              )
                            "
                            role="button"
                            tabindex="0"
                            style="
                              cursor: pointer;
                              color: #037493;
                              margin-left: 9px;
                              margin-top: 4px;
                            "
                            title="View Campaign Details"
                          ></ds-icon>
                        </span>
                      </span>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #quotationAction>
                  <ng-container
                    *ngIf="
                      column.field === 'quotationAction';
                      else outBoundAction
                    "
                  >
                    <div>
                      <span
                        style="display: flex; gap: 8px; align-items: center"
                      >
                        <span>
                          <ds-icon
                            icon="eye"
                            size="md"
                            title="Unit Summary"
                            style="
                              cursor: pointer;
                              color: #037493;
                              margin-left: 10px;
                            "
                            class="update millage"
                            (click)="openVehicleDetailsModal(row)"
                          ></ds-icon>
                        </span>
                      </span>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #outBoundAction>
                  <ng-container
                    *ngIf="
                      column.field === 'outboundAction';
                      else defaultContent
                    "
                  >
                    <div>
                      <span
                        style="display: flex; gap: 8px; align-items: center"
                      >
                        <span>
                          <ds-icon
                            icon="eye"
                            size="md"
                            title="Unit Summary"
                            style="
                              cursor: pointer;
                              color: #037493;
                              margin-left: 10px;
                            "
                            class="update millage"
                            (click)="openVehicleDetailsModal(row)"
                          ></ds-icon>
                        </span>
                      </span>
                    </div>
                  </ng-container>
                </ng-template>

                <ng-template #defaultContent>
                  <!-- VIN column -->
                  <ng-container *ngIf="column.field === 'VIN'; else checkDSP">
                    <a
                      [href]=" row[column.field] | unitOverviewLink"
                      target="_blank"
                      rel="noopener"
                      style="
                        font-weight: bold;
                        color: #037493;
                        text-decoration: none;
                        cursor: pointer;
                      "
                      title="View Unit Overview"
                    >
                      {{ row[column.field] }}
                    </a>
                  </ng-container>

                  <!-- Check for Visible on DSP -->
                  <ng-template #checkDSP>
                    <ng-container
                      *ngIf="column.field === 'visibleOnDSP'; else plainText"
                    >
                      <ng-container
                        *ngIf="row[column.field] !== null; else unknownValue"
                      >
                        <span
                          [ngClass]="{
                            'dsp-yes':
                              row[column.field].toString().toLowerCase() ===
                              'true',
                            'dsp-no':
                              row[column.field].toString().toLowerCase() ===
                              'false',
                          }"
                          class="dsp-badge"
                        >
                          {{
                            row[column.field].toString().toLowerCase() ===
                            'true'
                              ? 'Yes'
                              : 'No'
                          }}
                        </span>
                      </ng-container>

                      <ng-template #unknownValue>
                        <span class="dsp-badge dsp-no">No</span>
                        <!-- fallback or blank -->
                      </ng-template>
                    </ng-container>
                  </ng-template>

                  <!-- Default field rendering -->
                  <ng-template #plainText>
                    {{ row[column.field] }}
                  </ng-template>
                </ng-template>
              </ng-template>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<ds-modal
  #transferConfirmationModal
  [ds-modal-trigger-for]="transferConfirmationModal"
  [(isModalOpen)]="modalIsOpen"
  [dimensionsConfig]="{ width: '585px' }"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    <!--    Confirm Transfer-->
    Alert
  </ds-box-header>
  <ds-box-content>
    <div>
      <span>
        PDI has to be done within two working days from clicking OK. Are you
        sure you want to transfer {{ modalData.vin }}
        to Showroom storage?
      </span>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      (click)="close()"
      style="margin-right: 5px"
      variant="primary"
    >
      Cancel
    </button>
    <button
      ds-button
      (click)="transferVehicle(modalData.vin, modalData.modelCode)"
      variant="outline"
    >
      OK
    </button>
  </ds-box-footer>
</ds-modal>

<ds-modal
  #otpUploadModal
  [ds-modal-trigger-for]="otpUploadModal"
  [dimensionsConfig]="{ width: '520px' }"
  [(isModalOpen)]="otpModalIsOpen"
  (dismiss)="closeOtpModal()"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    Upload Customer ATR/Deposit Confirmation
  </ds-box-header>
  <ds-box-content>
    <div>
      <div style="display: flex; gap: 8px; align-items: center">
        <div style="width: 150px">VIN Number:</div>
        <div>{{ modalOTPData.vin }}</div>
      </div>
      <br />
      <span style="display: flex; align-items: center; gap: 8px">
        <div>
          <label ds-label for="file" style="width: 150px"
            >Finance Documents:</label
          >
        </div>
        <div>
          <input
            ds-input
            id="file"
            type="file"
            required
            accept="application/pdf"
            (change)="onFileChange($event)"
            [(ngModel)]="model"
            [ngClass]="{ error: !model }"
          />
        </div>
      </span>
      <br />
      <div style="display: flex; align-items: center; gap: 8px">
        <span style="color: #69707a; width: 235px"> </span>
        <span style="color: #69707a">
          Please upload approved finance application (ATR) or Proof of Deposit
          for a cash deal.
        </span>
      </div>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      style="
        background-color: #037493;
        color: white;
        padding-bottom: 8px;
        padding-right: 8px;
        padding-left: 8px;
        padding-top: 5px;
        border-radius: 3px;
        border: 1px solid #037493;
      "
      [disabled]="!model"
      (click)="
        uploadFinanceDocument(
          modalOTPData.vin,
          modalOTPData.modelCode,
          modalOTPData.dspReference
        )
      "
    >
      Upload
    </button>
  </ds-box-footer>
</ds-modal>

<ds-modal
  #responseModal
  [ds-modal-trigger-for]="responseModal"
  [(isModalOpen)]="responseModalIsOpen"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    {{ modalResponseData.title }}
  </ds-box-header>
  <ds-box-content>
    <div>
      <span>
        {{ modalResponseData.message }}
      </span>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button ds-button (click)="close()">Close</button>
  </ds-box-footer>
</ds-modal>

<ds-modal
  #acceptInbound
  [ds-modal-trigger-for]="acceptInbound"
  [(isModalOpen)]="inBoundmodalIsOpen"
  [dimensionsConfig]="{ width: '585px', height: 'auto' }"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    {{ inBoundmodalData.title }}
  </ds-box-header>
  <ds-box-content>
    <div>
      <span>
        {{ inBoundmodalData.message }}
      </span>
    </div>
  </ds-box-content>
  <ds-box-footer *ngIf="showInboundFooter">
    <button
      ds-button
      style="
        background-color: #037493;
        color: white;
        padding-bottom: 8px;
        padding-right: 8px;
        padding-left: 8px;
        padding-top: 5px;
        border-radius: 3px;
        border: 1px solid #037493;
      "
      (click)="close()"
    >
      Close
    </button>
  </ds-box-footer>
</ds-modal>

<ds-modal
  #demoMileageModal
  [ds-modal-trigger-for]="demoMileageModal"
  [(isModalOpen)]="demoMileageModalIsOpen"
  [dimensionsConfig]="{ width: '420px' }"
  (dismiss)="closeDemoMileageModal()"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    Update Vehicle Details
  </ds-box-header>
  <ds-box-content>
    <div>
      <div style="display: flex; gap: 8px; align-items: center">
        <div style="width: 150px">Vehicle:</div>
        <div>{{ demoMileageModalData.modelDescription }}</div>
      </div>
      <br />
      <div style="display: flex; gap: 8px; align-items: center">
        <div style="width: 150px">VIN Number:</div>
        <div>{{ demoMileageModalData.vin }}</div>
      </div>
      <br />
      <span style="display: flex; align-items: center; gap: 8px">
        <div>
          <label ds-label for="mileageText" style="width: 150px">
            Odometer reading:
          </label>
        </div>
        <div>
          <input
            ds-input
            id="mileageText"
            type="text"
            required
            placeholder="{{ demoMileageModalData.currentMileage }}"
            (input)="onTextChange($event)"
            [(ngModel)]="mileageModel"
          />
        </div>
      </span>
      <br />
      <div style="display: flex; align-items: center; gap: 8px">
        <span style="color: #69707a; width: 235px"> </span>
        <span
          *ngIf="isMileageGreater"
          disabled="isMileageGreater"
          class="error-message"
          style="color: red"
        >
          Odometer reading must be greater than
          {{ demoMileageModalData.currentMileage }}.
        </span>
      </div>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      style="
        background-color: #037493;
        color: white;
        padding-bottom: 8px;
        padding-right: 8px;
        padding-left: 8px;
        padding-top: 5px;
        border-radius: 3px;
        border: 1px solid #037493;
      "
      (click)="checkMileage(mileageModel, demoMileageModalData.currentMileage)"
    >
      Update Mileage
    </button>
  </ds-box-footer>
</ds-modal>

<ds-modal
  #requestInspectionModal
  [ds-modal-trigger-for]="requestInspectionModal"
  [(isModalOpen)]="requestInspectionModalIsOpen"
  [dimensionsConfig]="{ width: '420px' }"
  (dismiss)="closeRequestInspectionModal()"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    Request Vehicle Inspection
  </ds-box-header>
  <ds-box-content>
    <div>
      <div style="display: flex; gap: 8px; align-items: center">
        <div style="width: 150px">Vehicle:</div>
        <div>{{ requestInspectionModalData.modelDescription }}</div>
      </div>
      <br />
      <div style="display: flex; gap: 8px; align-items: center">
        <div style="width: 150px">VIN Number:</div>
        <div>{{ requestInspectionModalData.vin }}</div>
      </div>
      <br />
      <span style="display: flex; align-items: center; gap: 8px">
        <label ds-label for="inspectionDate" style="width: 250px">
          Inspection Date:
        </label>
        <input
          ds-input
          id="inspectionDate"
          type="date"
          required
          [(ngModel)]="inspectionDateModel"
        />
      </span>
      <br />
      <span style="display: flex; align-items: center; gap: 8px">
        <label ds-label for="inspectionTime" style="width: 250px">
          Inspection Time:
        </label>
        <input
          ds-input
          id="inspectionTime"
          type="time"
          required
          [(ngModel)]="inspectionTimeModel"
        />
      </span>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      style="
        background-color: #037493;
        color: white;
        padding-bottom: 8px;
        padding-right: 8px;
        padding-left: 8px;
        padding-top: 5px;
        border-radius: 3px;
        border: 1px solid #037493;
      "
      (click)="
        requestInspection(
          requestInspectionModalData.vin,
          requestInspectionModalData.modelDescription,
          inspectionDateModel,
          inspectionTimeModel,
          requestInspectionModalData.appraisalStatus
        )
      "
    >
      Request Inspection
    </button>
  </ds-box-footer>
</ds-modal>

<ds-modal
  #vehicleDetailsModal
  [ds-modal-trigger-for]="vehicleDetailsModal"
  [(isModalOpen)]="vehicleDetailsModalIsOpen"
  [dimensionsConfig]="{ width: '600px' }"
  [detachFooter]="true"
>
  <ds-box-header>
    <h1 class="vehicle-modal-title">Unit Summary</h1>
  </ds-box-header>

  <ds-box-content>
    <div *ngIf="selectedVehicle">
      <!-- Vehicle Image at Top -->
      <img
        *ngIf="selectedVehicle.image"
        [src]="selectedVehicle.image"
        alt="Vehicle Image"
        class="vehicle-modal-image"
      />
      <table class="vehicle-details-table">
        <tr>
          <td class="vehicle-label">VIN</td>
          <td>
            <a
              [href]="selectedVehicle['VIN'] | unitOverviewLink"
              class="vehicle-vin-link"
            >
              {{ selectedVehicle['VIN'] }}
            </a>
          </td>
        </tr>
        <tr>
          <td class="vehicle-label">Model</td>
          <td>{{ selectedVehicle['model'] }}</td>
        </tr>
        <tr>
          <td class="vehicle-label">Description</td>
          <td>
            {{
              selectedVehicle['description'] ||
                selectedVehicle['modelDescription']
            }}
          </td>
        </tr>
        <tr>
          <td
            class="vehicle-label"
            *ngIf="
              selectedVehicle['storageLocationAvail'] ||
              selectedVehicle['storageLocationAvailable']
            "
          >
            Storage Location
          </td>
          <td
            style="padding-left: 0"
            *ngIf="
              selectedVehicle['storageLocationAvail'] ||
              selectedVehicle['storageLocationAvailable']
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              {{
                selectedVehicle['storageLocationAvail'] ||
                  selectedVehicle['storageLocationAvailable']
              }}
              <!--              <ds-icon-->
              <!--                icon="exchange"-->
              <!--                size="md"-->
              <!--                title="Storage Location"-->
              <!--                style="cursor: pointer; color: #037493; padding-left: 8px"-->
              <!--                (click)="modalClickData(selectedVehicle['VIN'], selectedVehicle['model'])"-->
              <!--              ></ds-icon>-->
            </div>
          </td>
        </tr>
        <tr>
          <td class="vehicle-label">Visible on DSP</td>
          <td>
            <span
              [ngClass]="{
                'dsp-yes':
                  selectedVehicle['visibleOnDSP']?.toString().toLowerCase() ===
                  'true',
                'dsp-no':
                  selectedVehicle['visibleOnDSP']?.toString().toLowerCase() ===
                  'false',
              }"
              class="dsp-badge"
            >
              {{
                selectedVehicle['visibleOnDSP']?.toString().toLowerCase() ===
                'true'
                  ? 'Yes'
                  : 'No'
              }}
            </span>
          </td>
        </tr>
        <tr>
          <td
            class="vehicle-label"
            [hidden]="selectedVehicle['rfsDate'] !== ''"
          >
            RFS Date
          </td>
          <td [hidden]="selectedVehicle['rfsDate'] !== ''">
            {{ selectedVehicle['rfsDate'] }}
          </td>
        </tr>
        <tr>
          <td
            class="vehicle-label"
            [hidden]="selectedVehicle['rfiWeek'] !== ''"
          >
            RFI Week
          </td>
          <td [hidden]="selectedVehicle['rfiWeek'] !== ''">
            {{ selectedVehicle['rfiWeek'] }}
          </td>
        </tr>
      </table>
    </div>
  </ds-box-content>

  <div class="vehicle-modal-footer">
      <a
              [href]="selectedVehicle?.VIN | unitOverviewLink"
              class="modal-btn view-more-btn"
              target="_blank"
      >
      Go to Unit Overview
    </a>
  </div>
</ds-modal>

<ds-modal
  #uploadLicenseDocsModal
  [ds-modal-trigger-for]="uploadLicenseDocsModal"
  [(isModalOpen)]="uploadLicenseDocsModalIsOpen"
  [dimensionsConfig]="{ width: '450px' }"
  (dismiss)="closeUploadLicenseDocsModal()"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    Upload Vehicle Documents
  </ds-box-header>
  <ds-box-content>
    <div>
      <div style="display: flex; gap: 8px; align-items: center;margin-bottom: 5px">
        <div style="width: 150px">Vehicle:</div>
        <div>{{ licenseModalData.modelDescription }}</div>
      </div>
      <div style="display: flex; gap: 8px; align-items: center;margin-bottom: 5px">
        <div style="width: 150px">VIN Number:</div>
        <div>{{ licenseModalData.vin }}</div>
      </div>
      <span style="display: flex; align-items: center; gap: 8px;margin-bottom: 7px">
        <div>
          <label ds-label for="mileageText" style="width: 150px">
            License Date:
          </label>
        </div>
        <div>
          <ds-form-field>
            <ds-datepicker [viewDate]="viewDate" [(config)]="dateConfig">
              <input ds-date [(ngModel)]="viewDate" />
            </ds-datepicker>
          </ds-form-field>
        </div>
      </span>
      <span style="display: flex; align-items: center; gap: 8px;margin-bottom: 7px">
        <div>
          <label ds-label for="mileageText" style="width: 150px">
            Registration nr:
          </label>
        </div>
        <div>
          <input
            ds-input
            id="mileageText"
            type="text"
            required
            placeholder="Enter Vehicle Reg. nr"
            (input)="onRegNrTextChange($event)"
            [(ngModel)]="regNumberModel"
          />
        </div>
      </span>
      <span style="display: flex; align-items: flex-start; gap: 8px;">
        <div>
          <label ds-label for="file" style="width: 150px"
          >Reg. Documents:</label
          >
        </div>
        <div>
          <input
            ds-input
            id="file"
            type="file"
            required
            accept="application/pdf"
            (change)="onLicenseDocFileChange($event)"
            [(ngModel)]="licenseDoc"
          />
          <span style="color: red;">NB: Please upload MVL1 (Motor vehicle licence and licence disc) document</span>
        </div>
      </span>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="outline"
      style="margin-right: 5px"
      (click)="closeUploadLicenseDocsModal()"
    >
      Close
    </button>

    <button
      ds-button
      variant="primary"
      (click)="uploadLicenseDocs()"
    >
      Upload Documents
    </button>
  </ds-box-footer>
</ds-modal>
